import { formatPersonName } from "@/lib/formatPersonName";
import type { OrganizationMember } from "@/types/emailReports";
import type { UserBookingAssignment } from "@/types/api";

function linkedUserLabel(
  name: string | null | undefined,
  email: string | null | undefined,
): string | undefined {
  const trimmedName = name?.trim();
  if (trimmedName) return trimmedName;
  const trimmedEmail = email?.trim();
  if (trimmedEmail) return trimmedEmail;
  return undefined;
}

export function resolveOpenedByDisplay(
  raw: string | undefined,
  assignments: UserBookingAssignment[],
): string | undefined {
  if (!raw?.trim()) return undefined;
  const match = assignments.find(
    (a) =>
      a.field_value.trim().toLowerCase() === raw.trim().toLowerCase(),
  );
  if (!match) return formatPersonName(raw);
  return (
    linkedUserLabel(match.user_name, match.user_email) ?? formatPersonName(raw)
  );
}

export function resolveSalesPersonDisplay(
  raw: string | undefined,
  members: OrganizationMember[],
): string | undefined {
  if (!raw?.trim()) return undefined;
  const match = members.find(
    (m) =>
      m.sales_person_link?.trim().toLowerCase() === raw.trim().toLowerCase(),
  );
  if (!match) return formatPersonName(raw);
  return linkedUserLabel(match.name, match.email) ?? formatPersonName(raw);
}

export function resolvePartyNameDisplay(
  name: string | undefined,
  id: string | undefined,
): string | undefined {
  const trimmedName = name?.trim();
  if (trimmedName) {
    return /_/.test(trimmedName) ? formatPersonName(trimmedName) : trimmedName;
  }
  const trimmedId = id?.trim();
  if (trimmedId) return formatPersonName(trimmedId);
  return undefined;
}
